// extracted by mini-css-extract-plugin
export var active = "_47-7";
export var container = "_47-0";
export var evenWidth = "_47-4";
export var large = "_47-5";
export var outlet = "_47-8";
export var slide = "_47-2";
export var small = "_47-6";
export var tab = "_47-3";
export var tabs = "_47-1";